module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/phrases/phrases-admin.component.css
// module id = ./src/app/admin/phrases/phrases-admin.component.css
// module chunks = main